import type * as React from 'react';

function PremiumLock(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="100%"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 18 21"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 12V14.25M0.75 8.25V19.5H17.25V8.25H0.75ZM3.75 8.25C3.75 3.75 3.75 0.75 9 0.75C14.25 0.75 14.25 3.75 14.25 8.25H3.75Z"
        stroke="#00182E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export default PremiumLock;
